module.exports = __webpack_public_path__ + "static/img/03.b84971b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/03.jpg
// module id = N5p1
// module chunks = 0